export default __webpack_public_path__ + "static/media/rejected.ab1709c9.svg";